import React from 'react';
import { StyledH1, StyledH2, StyledH3, StyledHeaderWithIcon } from './styles';
export const H1 = (props) => (React.createElement(StyledH1, { ...props }));
export const H2 = (props) => (React.createElement(StyledH2, { ...props }));
export const H3 = (props) => (React.createElement(StyledH3, { ...props }));
export const HeaderWithIcon = ({ icon, children, tag = 'h1', textWeight, iconSize = 26, }) => {
    const Icon = icon;
    return (React.createElement(StyledHeaderWithIcon, { textWeight: textWeight, as: tag },
        React.createElement(Icon, { width: iconSize, height: iconSize }),
        children));
};
//# sourceMappingURL=headers.js.map